module.exports = __webpack_public_path__ + "img/扩充工厂.d63866f3.svg";